export default __webpack_public_path__ + "static/media/Asset2_MainBanner_RidingBus.fc18d3cf.jpeg";